var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1402 3.15479C16.7153 3.15479 17.9828 4.43164 17.9828 6.00673V9.21283C15.6901 10.5549 12.6611 11.3658 9.36175 11.3658C6.06244 11.3658 3.04274 10.5549 0.75 9.21283V5.99741C0.75 4.42232 2.02685 3.15479 3.60194 3.15479H15.1402Z",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6285 3.15085V2.80974C12.6285 1.67269 11.7059 0.75 10.5688 0.75H8.16423C7.02718 0.75 6.10449 1.67269 6.10449 2.80974V3.15085",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.772751 12.6177L0.9489 14.9561C1.0682 16.5321 2.3814 17.7502 3.96115 17.7502H14.7715C16.3513 17.7502 17.6645 16.5321 17.7837 14.9561L17.9599 12.6177",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersIcon);
export default __webpack_public_path__ + "static/media/partnersIcon.a2498d1fe558a3537f40fbe8eae7666e.svg";
export { ForwardRef as ReactComponent };